import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function OfferingsRocket() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <br />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="summary">등기부등본이 필요 없는 로켓등록 서비스가 무제한 무료!{t0}야간에도, 주말에도 빠르게 노출되어, 광고효과 UP!<br />(BASIC 이상 멤버쉽 구독 시)</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t1}<ol className="list_order"><li><h4 className="order_num">Step 1</h4><Image className="img_guide" src="/image/mobile/popup/offerings02_01.png" alt={"\uAC80\uC99D\uBC29\uC2DD \uC120\uD0DD"} width={100} height={100} /></li><li><h4 className="order_num">Step 2</h4><Image className="img_guide" src="/image/mobile/popup/offerings02_02.png" alt={"\uCDA9\uC804\uAE08\uC774 \uC801\uC6A9\uB418\uC5C8\uC5B4\uC694."} width={100} height={100} /></li></ol></>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}